export const LOADER_STATUS = 'boilderplate/Gstr1New/File/LOADER_STATUS';
export const FILE_TABLE_DATA = 'boilderplate/Gstr1New/File/FILE_TABLE_DATA';


